import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable, Modal } from 'components/basic'
import AnimateHeight from 'react-animate-height'
import FlowView from 'components/core/FlowView'
import http from 'API/http'
import FileUpload from '../../../components/core/FileUpload.js'
import { notify } from 'helpers'
import { Installation } from 'config'

class UserOverview extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      loading: true,
      searchQuery: '',
      users: [],
      modalState: false,
      showImport: false
    }
  }

  componentDidMount () {
    this.getUsers()
  }
  async getUsers() {
    var err, res
    [err, res] = await http.get('2.4/users/')
    if (err) return this.setState({users: [], loading: false})
    this.setState({users: res.data, loading: false})
  }
  showImport () {
    this.setState({showImport: !this.state.showImport})
  }

  async export () {
    var err, res
    [err, res] = await http.get('2.4/users/export')
    if (err) return notify.alert('', res.message ? res.message : res.cause, 'error')
    let csv = res.data
    let fileName = 'usersExport.csv'
    var blob = new Blob([csv], {type: 'text/csv'})
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, fileName)
    } else {
      var elem = window.document.createElement('a')
      elem.href = window.URL.createObjectURL(blob)
      elem.download = fileName
      document.body.appendChild(elem)
      elem.click()
      document.body.removeChild(elem)
    }
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Users' subtitle='Overview' icon='fa-users' buttons={[
          { icon: 'fa-upload', tip: 'Import', event: () => this.setState({showImport: !this.state.showImport}) },
          { icon: 'fa-download', tip: 'Export', event: () => this.export() },
          { icon: 'fa-plus', tip: 'Add User', event: () => (window.location = '/#/users/create') }]} />
        <hr />
        <div className='row'>
          <AnimateHeight duration={500} height={(this.state.showImport ? 'auto' : '0')}>
            <StaticBox icon='box-icon fa fa-fw fa-upload' title='Import Users from .CSV' >
              <FileUpload
                displayInline
                reload={() => this.getUsers()}
                url={Installation.api_base + '2.4/users/import'}
              />
            </StaticBox>
          </AnimateHeight>
          <StaticBox cols={12} icon='box-icon fa fa-fw fa-users' title='Users'>
            <FlowTable loading={this.state.loading} paginatable={30} data={this.state.users.map(user => [
              { onClick: e => (window.location.href = '/#/users/' + user.userId) },
              <a href={'/#/users/' + user.userId} className='table-link'><i className='fa fa-folder-open-o' /></a>,
              user.name,
              user.username,
              user.email,
              (user.isAdmin && <span className='label orders-label label-success'><b>Admin</b></span>)
            ])}>
              <tr>
                <th className='buttons' />
                <th>Name</th>
                <th>Username</th>
                <th>Email</th>
                <th>Admin</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
UserOverview = connect(state => state.siteReducer)(UserOverview)
export default UserOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/users/overview.js